import React from "react"
import Layout from "../components/Layout"
import Info from "../components/Info"
import Birds from "../components/Birds"
import CloudOne from "../components/clouds/CloudOne"
import CloudTwo from "../components/clouds/CloudTwo"
import CloudThree from "../components/clouds/CloudThree"
import IconContainer from "../components/Icons/IconContainer"

const Index = () => (
	
  <Layout>
   
    <div style={{ maxWidth: '100%'}}>
       <IconContainer/>
      <Info/> 
      <CloudTwo/>
      <Birds/>
      <CloudThree/>
     <CloudOne/>
    </div>
    
  </Layout>
)

export default Index
